/**
 * Asynchronously loads the component for LeaderBoardPage
 */

import { lazyLoad } from "@utils/loadable";

export const LeaderBoardPage = lazyLoad(
  () => import("./index"),
  (module) => module.LeaderBoardPage
);
